import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {environment as env} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BannerServiceService {

  constructor(private http:HttpClient) { }

  getHomeBannerSliderList(){
    //https://saj.showmeproject.com/sajadmin/api/orders
    return this.http.get<any>(env.apiurl+'get-banner/Home Banner', {})
      .pipe(map(homeBanner => {
        if (homeBanner) {            
          return homeBanner;
        }
      }),
     // catchError(this.handleError)
    );

  }


  getHomeBannerBestSellerList(){
    //https://saj.showmeproject.com/sajadmin/api/orders
    return this.http.get<any>(env.apiurl+'get-banner/Home Page Best Seller', {})
      .pipe(map(homeBanner => {
        if (homeBanner) {            
          return homeBanner;
        }
      }),
     // catchError(this.handleError)
    );

  }
}
